function initPage7(vm, FileTemplateService, self) {
	vm.defaultPage7 = function() {
		var contractTypeValue = vm.proposal.contractType;
		var mapRiders = [];
		for (var i = 0; i < vm.proposal.laList.length; i++) {
			if (vm.proposal.laList[i].customer != null
					&& vm.proposal.laList[i].customer.idNum !== undefined
					&& vm.proposal.laList[i].customer.idNum !== null
					&& vm.proposal.laList[i].customer.idNum !== ''
					&& vm.proposal.laList[i].customer.lastName != null
					&& vm.proposal.laList[i].customer.firstName != null
					&& vm.proposal.laList[i].customer.lastName != ''
					&& vm.proposal.laList[i].customer.firstName != '') {
				var map = {
					dob : vm.proposal.laList[i].customer.dob,
					age : vm.proposal.laList[i].customer.age,
					relationshipCode : vm.proposal.laList[i].relationshipCode,
					numLa : i,
					components : vm.proposal.laList[i].riderList
				};
				mapRiders.push(map);
			}
		}
		// load laRiderConfigs
		var parameters = {
			contractType : contractTypeValue,
			mapRiders : mapRiders,
			isPoLA : vm.proposal.isPoLA,
			gender: vm.proposal.po.customer.gender
		};

		FileTemplateService
				.postList(
						{
							uri : 'getRiders'
						},
						parameters,
						function(result) {
							vm.listLaRiderConfig = result;
							if (result != null && result[0] != undefined
									&& result[0] != null) {
								vm.notRider = result[0].notRider;
							} else {
								vm.notRider = false;
							}

							for (var i = 0, size = vm.listLaRiderConfig.length; i < size; i++) {
								var laRiderConfig = vm.listLaRiderConfig[i];
								for (var j = 0, length = laRiderConfig.riderConfigRules.length; j < length; j++) {
									
									if (!vm.proposal.agentCode.startsWith('69') && parameters.contractType == 'VL7' && laRiderConfig.numLa == 0 && ('VCI2' == laRiderConfig.riderConfigRules[j].code
											|| 'VCW2' == laRiderConfig.riderConfigRules[j].code)) {
										laRiderConfig.riderConfigRules[j].checked = true;
									} else if (parameters.contractType == 'TH2' && laRiderConfig.numLa == 0 && 'HCR2' == laRiderConfig.riderConfigRules[j].code) {
										laRiderConfig.riderConfigRules[j].checked = true;
									} else if (parameters.contractType == 'TH3' && laRiderConfig.numLa == 0 && 'HCR1' == laRiderConfig.riderConfigRules[j].code) {
										laRiderConfig.riderConfigRules[j].checked = true;
									} else if (parameters.contractType == 'VL8' && laRiderConfig.numLa != 0 && ('VTR2' == laRiderConfig.riderConfigRules[j].code 
											|| 'VDW2' == laRiderConfig.riderConfigRules[j].code)) {
										laRiderConfig.riderConfigRules[j].checked = true;
									}
									
									vm.checkValidateEntryAge(
											laRiderConfig.riderConfigRules[j],
											laRiderConfig.numLa,
											laRiderConfig.riderConfigRules);
								}
							}
						});
	};

	vm.validatePage7 = function() {
		var flag = false;
		flag = vm.validateAllRequired(flag);
		var customerAvailable = 0;
		for (var i = 0; i < vm.proposal.laList.length; i++) {
			if (vm.proposal.laList[i].customer.idNum !== undefined
					&& vm.proposal.laList[i].customer.idNum !== null
					&& vm.proposal.laList[i].customer.idNum !== '') {
				customerAvailable++;
			}
		}
		if (vm.listLaRiderConfig.length !== customerAvailable) {
			self.addAlert('NĐBH chưa chọn sản phẩm bảo hiểm bổ trợ!', 'danger');
			flag = true;
		}
		for (var i = 0, size = vm.listLaRiderConfig.length; i < size; i++) {
			var laRiderConfig = vm.listLaRiderConfig[i];
			for (var j = 0, length = laRiderConfig.riderConfigRules.length; j < length; j++) {

				// vm.checkValidateEntryAge(laRiderConfig.riderConfigRules[j],
				// laRiderConfig.numLa);
				var ckHCR1, ckUHS4, ckHCR3 = false;
				if (laRiderConfig.riderConfigRules[j].checked) {
					// vm.proposal.laList[lalaRiderConfig.riderConfigRules[j].numLa].customer.dob;
					var dob = new Date(
							vm.proposal.laList[laRiderConfig.numLa].customer.dob)
							.getTime();
					var currentDate = new Date().getTime();
					if (laRiderConfig.riderConfigRules[j].code == 'KID1'
							|| laRiderConfig.riderConfigRules[j].code == 'KID2'
							|| laRiderConfig.riderConfigRules[j].code == 'KID3'
							|| laRiderConfig.riderConfigRules[j].code == 'KID4'
							|| laRiderConfig.riderConfigRules[j].code == 'KID5'
							|| laRiderConfig.riderConfigRules[j].code == 'KID6'
							|| laRiderConfig.riderConfigRules[j].code == 'KID7'
							|| laRiderConfig.riderConfigRules[j].code == 'KID8'
							|| laRiderConfig.riderConfigRules[j].code == 'KID9'
							|| laRiderConfig.riderConfigRules[j].code == 'CIR4'
							|| laRiderConfig.riderConfigRules[j].code == 'ADD6') {
						var diff = currentDate - dob;
						var diffDays = diff / (24 * 60 * 60 * 1000);
						if(parseInt(diffDays) < 30) {
							self
							.addAlert(
									'Người được bảo hiểm chưa đủ tuổi tham gia sản phẩm.',
									'danger');
							laRiderConfig.riderConfigRules[j].checked = false;
							flag = true;
						}
					}
					if (laRiderConfig.riderConfigRules[j].code == 'HCR1') {
						ckHCR1 = true;
					}
					if (laRiderConfig.riderConfigRules[j].code == 'HCR3') {
						ckHCR3 = true;
					}
					if (laRiderConfig.riderConfigRules[j].code == 'UHS4') {
						ckUHS4 = true;
					}
					
					if((ckHCR1 && ckHCR3) || (ckHCR1 && ckUHS4) || (ckHCR3 && ckUHS4) || (ckHCR1 && ckHCR3 && ckUHS4)) {
						var msg = '';
						msg = 'Sản phẩm [UHS4] không mua kèm với sản phẩm [HCR1] và [HCR3].';
						vm.validDsrOpw = false;
						vm.msgDsrOpw = msg;
//						self.addAlert( msg, 'danger');
//						return;
					}
				}
			}
		}
		if (!flag) {
			setLaRider(vm);
			for (var i = 0; i < vm.listLaRiderConfig.length; i++) {
				if (vm.listLaRiderConfig[i].numLa != 0
						&& vm.proposal.laList[vm.listLaRiderConfig[i].numLa].riderList.length == 0
						|| vm.checkRiderNull) {
					var fulName = vm.proposal.laList[vm.listLaRiderConfig[i].numLa].customer.lastName
							+ ' '
							+ vm.proposal.laList[vm.listLaRiderConfig[i].numLa].customer.firstName;
					self.addAlert(fulName
							+ ' chưa chọn sản phẩm bảo hiểm bổ trợ!', 'danger');
					flag = true;
					// break;
				}
			}
		}
		if(!vm.validDsrOpw) {
			flag = true;
			self.addAlert(vm.msgDsrOpw,'danger');
		}
		return flag;
	}

}
function setLaRider(vm) {
	for (var i = 0; i < vm.listLaRiderConfig.length; i++) {
		vm.proposal.laList[vm.listLaRiderConfig[i].numLa].riderList = [];
		for (var j = 0; j < vm.listLaRiderConfig[i].riderConfigRules.length; j++) {
			if (vm.listLaRiderConfig[i].riderConfigRules[j].checked
					&& vm.listLaRiderConfig[i].riderConfigRules[j].component !== undefined
					&& vm.listLaRiderConfig[i].riderConfigRules[j].component !== null) {
				var riderLa = {
					componentCode : vm.listLaRiderConfig[i].riderConfigRules[j].code,
					sumAssured : vm.listLaRiderConfig[i].riderConfigRules[j].component.sumAssured,
					policyTerm : vm.listLaRiderConfig[i].riderConfigRules[j].component.policyTerm,
					premiumTerm : vm.listLaRiderConfig[i].riderConfigRules[j].component.premiumTerm,
					option : vm.listLaRiderConfig[i].riderConfigRules[j].component.option,
					rate : vm.listLaRiderConfig[i].riderConfigRules[j].component.rate
				};
				vm.proposal.laList[vm.listLaRiderConfig[i].numLa].riderList
						.push(riderLa);
			} else if (vm.listLaRiderConfig[i].riderConfigRules[j].checked
					&& (vm.listLaRiderConfig[i].riderConfigRules[j].component === undefined || vm.listLaRiderConfig[i].riderConfigRules[j].component === null)) {
				var riderLa = {
					componentCode : vm.listLaRiderConfig[i].riderConfigRules[j].code,
					sumAssured : null,
					policyTerm : null,
					premiumTerm : null,
					option : null,
					rate : null
				};
				vm.proposal.laList[vm.listLaRiderConfig[i].numLa].riderList
						.push(riderLa);
			}
		}
	}
}